import gql from "graphql-tag";
import classNames from "classnames";
import {
  TextAndText as TextAndTextProps,
} from "../../../../__generated__/graphql";
import { ContentfulComponentType } from "../types";
import styles from "./TextAndText.module.css";
import TextFieldsV2 from "../TextFieldsV2";

export const ContentfulTextAndText: ContentfulComponentType<
  TextAndTextProps
> = ({ leftTitle, leftText, rightTitle, rightText }) => {
  return (
    <div className={classNames(styles.container, "container")}>
      <div className={styles.textContainer}>
        <TextFieldsV2
          title={leftTitle}
          text={leftText}
          variantText="bodyRg"
          gutterBottom={0}
        />
      </div>
      <div className={styles.textContainer}>
        <TextFieldsV2
          title={rightTitle}
          text={rightText}
          variantText="bodyRg"
          gutterBottom={0}
        />
      </div>
    </div>
  );
};

ContentfulTextAndText.fragment = gql`
  fragment TextAndText on ComponentTextAndText {
    leftHighlight
    leftTitle
    leftText
    rightHighlight
    rightTitle
    rightText
    sys {
      id
      publishedAt
    }
  }
`;
